
<template>
  <div>
    <template v-if="!wapShow">


    <headers :menuIndex="3"></headers>
    <div class="technological-banner">
      <div class="app-content" style="position: relative;height: 600px">
        <p class="sp1">产学研，硬科技</p>
        <p class="sp2">交达凝聚联合高校、企业、机构等人才，以“专精特新”为引领，倾注热情实践“产学研融政”协同创新</p>
      </div>
    </div>

    <div class="technological-box1">
      <div class="app-content">
        <p class="t1">创新发展</p>
        <p class="t2">20 余年来，得益于国内基础建设的快速发展和巨大成就的同时，团队秉承着“敬天爱人、需求引领”的根本理念，高度聚焦工程建设的品质提升工作。依托科技部、交通部等重大项目的研究基础，团结与凝聚了工程建设领域、先进制造领域和信息技术领域的高校、企业、机构等人才，以“专精特新”精神为引领，倾注热情实践“产学研融政”协同创新，用持续进化的产品和深入人心的服务，把研发和创新落在工程建设的大地之上。</p>
        <div class="flex-center technological-box1-t1">
          <img class="img1" src="@/assets/imgs/technological/2.png" />
          <span  class="img3" style="left: 128px;top: 130px;">产学研、硬科技</span>
          <img class="img2" src="@/assets/imgs/technological/3.png" />
          <span  class="img2" style="left: 882px;top: 74px">新方案、新价值</span>
          <img class="img3" src="@/assets/imgs/technological/4.png" />
          <span  class="img2"  style="top: 241px;
    left: 974px;">高度聚焦，专精特新</span>
          <img class="img2" src="@/assets/imgs/technological/3.png" style="    top: 239px;left: 780px;" />
          <img class="img3" src="@/assets/imgs/technological/4.png" style="    top: 312px;left: 244px;" />
          <span class="img3" style="top: 315px;left: 8px;">敬天爱人，需求引领</span>
        </div>
      </div>

    </div>

    <div class="technological-box2">
      <div class="app-content">
      <p class="box2-t1">创新体系</p>
        <div class="box2-ul flex-sp">
          <div class="box2-li">
            <div class="box2-li-header flex" style="align-items: center">01 <span class="line"></span> 团队</div>
            <ul>
              <li>多学科跨界融合于土木工程</li>
              <li>聚集顶尖高新技术专业人才</li>
            </ul>
            <div class="box2-lis"></div>
          </div>

          <div class="box2-li">
            <div class="box2-li-header flex" style="align-items: center">02 <span class="line"></span> 平台</div>
            <ul>
              <li>凝聚高校、央企、政府机构</li>
              <li>长期聚焦预应力的研究实践</li>
              <li>构建开放式创新的专业生态</li>
            </ul>
            <div class="box2-lis"></div>
          </div>
          <div class="box2-li">
            <div class="box2-li-header flex" style="align-items: center">03 <span class="line"></span> 文化</div>
            <ul>
              <li>至善、使命、热爱、聚焦、硬科技</li>
              <li>“产、学、研、融、政”协同创新</li>
              <li>新理念、新方案、新装备、新业态</li>
            </ul>
            <div class="box2-lis"></div>
          </div>
          <div class="box2-li">
            <div class="box2-li-header flex" style="align-items: center">04 <span class="line"></span> 机制</div>
            <ul>
              <li>利他主义的多方共赢机制</li>
              <li>高度聚焦的产业科技研发</li>
              <li>跨界融合的技术整合机制</li>
              <li>持续迭代的研究开发模式</li>
            </ul>
            <div class="box2-lis"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="technological-box3">
      <img src="@/assets/imgs/technological/1.png" />
    </div>

    <div class="technological-box7">
      <div class="app-content">
        <div class="box7-title">部分科研项目展示</div>
        <div class="box7-ul" >
          <div class="box7-li" v-for="item in list2">
            <img src="@/assets/imgs/technological/21.png">
            <div class="text1">{{item.type}}</div>
            <div class="box7-li-text">{{item.name}}</div>
            <div class="box7-li-text2" v-for="items in item.tag1">{{items}}</div>
          </div>
        </div>

        <page style="margin-top: 40px" :selectIndex="selectIndex2" :pageIndex="pageIndex2"  @last="selectIndex2--,getScientificList()" @next="selectIndex2++,getScientificList()"></page>
      </div>
    </div>

    <div class="technological-box4">
      <div class="app-content">
        <div class="box4-title">部分知识产权展示</div>

        <div class="box4-ul">
          <div class="box4-li" v-for="item in list1">
            <div class="box4-li-header flex">{{item.type}}<span style="margin-left: 32px">{{item.code}}</span></div>
            <div class="box4-li-content  flex-center" :title="item.digest">{{item.name}}</div>
          </div>
        </div>
        <page style="margin-top: 40px" :selectIndex="selectIndex1" :pageIndex="pageIndex1" @last="selectIndex1--,getIntellectualList()" @next="selectIndex1++,getIntellectualList()"></page>
      </div>
    </div>


    <div class="technological-box5">
      <div class="app-content">
        <div class="box5-title">团队荣誉</div>
        <el-carousel :interval="4000" :indicator-position="'none'" type="card" height="570px" style="margin-top: 64px">
          <el-carousel-item style="box-shadow: 0px 3px 36px 1px rgba(0,0,0,0.1000);">
            <img style="width: 100%;object-fit: cover" src="@/assets/imgs/technological/6.png" />
            <div  class="box5-title2">科技进步奖——锚杆（索）锚质量无损检测技术与仪器开发</div>
          </el-carousel-item>
          <el-carousel-item style="box-shadow: 0px 3px 36px 1px rgba(0,0,0,0.1000);">
            <img style="width: 100%;object-fit: cover" src="@/assets/imgs/technological/7.png" />
            <div  class="box5-title2">科技进步奖——锚杆（索）锚质量无损检测技术与仪器开发</div>
          </el-carousel-item>
          <el-carousel-item style="box-shadow: 0px 3px 36px 1px rgba(0,0,0,0.1000);">
            <img style="width: 100%;object-fit: cover" src="@/assets/imgs/technological/8.png" />
            <div  class="box5-title2">科技进步奖——锚杆（索）锚质量无损检测技术与仪器开发</div>
          </el-carousel-item>
        </el-carousel>
      </div>

    </div>

      <div class="technological-box6">
        <div class="app-content" style="position: relative;    overflow: initial;">
          <p class="box6-title">部分发明专利展示</p>
          <p class="box6-title1">截至2022年7月</p>
          <p class="box6-title2">公司申请专利</p>
          <p class="box6-title3">50<span style="margin-left: 20px;font-size: 40px">项</span></p>
          <p class="box6-line"></p>
          <div class="box6-box1 flex-sp ">
            <div class="box6-li">
              <p class="li6-1">发明专利</p>
              <p class="li6-2">25<span style="font-size: 36px;margin-left: 10px">项</span></p>
            </div>
            <div class="box6-li">
              <p class="li6-1">实用新型</p>
              <p class="li6-2">20<span style="font-size: 36px;margin-left: 10px">项</span></p>
            </div>
            <div class="box6-li">
              <p class="li6-1">软件著作</p>
              <p class="li6-2">5<span style="font-size: 36px;margin-left: 10px">项</span></p>
            </div>
          </div>
          <img class="technological-box6-img" src="@/assets/imgs/technological/23.png"/>
          <div class="box-img flex">
            <div style="margin-top: 112px">
              <img src="@/assets/imgs/technological/9.png"/>
              <img src="@/assets/imgs/technological/10.png"/>
              <img src="@/assets/imgs/technological/11.png"/>
            </div>
            <div style="margin-top: 112px">
              <img src="@/assets/imgs/technological/12.png"/>
              <img src="@/assets/imgs/technological/1.jpg"/>
              <img src="@/assets/imgs/technological/2.jpg"/>
            </div>
            <div style="margin-top: 162px">
              <img src="@/assets/imgs/technological/3.jpg"/>
              <img src="@/assets/imgs/technological/4.jpg"/>
              <img src="@/assets/imgs/technological/5.jpg"/>
            </div>
            <div>
              <img src="@/assets/imgs/technological/18.png"/>
              <img src="@/assets/imgs/technological/19.png"/>
              <!--            <img src="@/assets/imgs/technological/20.jpg" />-->
            </div>
          </div>
        </div>
      </div>

    <footers></footers>
    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>
  </div>
</template>


<script type="text/javascript">

  import headers from "@/components/header1"
  import footers from "@/components/footers"
  import page from "@/components/page"
  import axios from 'axios'
  import eventBus from "../../assets/js/eventBus";
  import wapIndex from "../technological/wapIndex";

  export default {
    name: 'technological',
    components:{headers,footers,page,wapIndex},
    data(){
      return{
        selectIndex1:1,
        pageIndex1:0,
        list2:[],
        selectIndex2:1,
        pageIndex2:0,
        list1:[],
        wapShow:false,
      }
    },
    mounted() {
      eventBus.$on("wapShow",(data)=> {
        this.wapShow = data;
        if(!this.wapShow) {
          this.getScientificList();
          this.getIntellectualList();
        }
        })
    },
    methods:{

      //获取科研项目
      getScientificList(){
        axios.get(this.pageUrl+`/scientific-project/page?pageNo=${this.selectIndex2}&pageSize=6`).then(res=>{
         this.pageIndex2=res.data.data.pages;
          res.data.data.list.forEach((item)=>{
            item.tag1 = item.tags?item.tags.split(","):[]
          })
         this.list2 = res.data.data.list;

        })
      },


      //获取知识产权
      getIntellectualList(){
        axios.get(this.pageUrl+`/intellectual-right/page?pageNo=${this.selectIndex1}&pageSize=6`).then(res=>{
          this.pageIndex1=res.data.data.pages;
          this.list1 = res.data.data.list;
        })
      }
    },


  }
</script>
<style>
  .technological-box5 .el-carousel__container{
    margin-bottom: 40px;
  }
</style>
<style scoped>
  .technological-box6 {
    margin-top: 100px;
    width: 100%;
    overflow: hidden;
    padding-bottom: 128px;
    height: 1000px;
  }

  .technological-box6 .box-img {
    position: absolute;
    top: 0;
    width: 860px;
    right: -300px;
  }

  .technological-box6 .box-img img {
    width: 217.62px;
  }

  .technological-box6 .box6-title {
    font-size: 40px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
  }

  .technological-box6 .box6-title1 {
    font-size: 24px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 131px;
  }

  .technological-box6 .box6-title2 {
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #0071EF;
    margin-top: 41px;
  }

  .technological-box6 .box6-title3 {
    font-size: 80px;
    font-family: DIN Alternate-Bold, DIN Alternate;
    font-weight: bold;
    color: #0071EF;
    margin-top: 71px;
  }

  .technological-box6 .box6-line {
    width: 570px;
    height: 2px;
    background: #5C5D5F;
    margin-top: 90px;
  }

  .technological-box6 .box6-box1 {
    margin-top: 41px;
    width: 560px;
  }

  .technological-box6 .box6-box1 .li6-1 {
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
  }

  .technological-box6 .box6-box1 .li6-2 {
    font-size: 50px;
    font-family: DIN Alternate-Bold, DIN Alternate;
    font-weight: bold;
    color: #19203B;
    margin-top: 33px;
  }

  .technological-box6-img {
    position: absolute;
    width: 600px;
    right: -70px;
    top: 140px;
  }
  .technological-banner{
    width: 100%;
    height: 560px;
    background-color: #19203B;
    background-image: url("../../assets/imgs/technological/31.png");
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    margin-top: 80px;
  }
  .technological-banner img{
    position: absolute;
    width: 850px;
    height: 592px;
    object-fit: cover;
    z-index: 4;
    right: 0;
    top: 196px;
  }
  .technological-banner .sp1{
    font-size: 38px;
    font-family: Microsoft YaHei;
    color: #000000;
    position: absolute;
    letter-spacing: 6px;
    font-weight: bold;
    line-height: 2;
    width: 600px;
    top: 90px;
    animation-name: fadeInUp;
    opacity: 0;
    animation-duration:1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
  }
  .technological-banner .sp2{
    font-size: 24px;
    letter-spacing: 4px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    position: absolute;
    top: 220px;
    animation-name: fadeInUp;
    opacity: 0;
    animation-delay: 1s;
    animation-duration:1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    color: rgba(92, 93, 95, 1);
    width: 800px;
    line-height: 2;
  }

  .technological-box1{
    margin-top: 20px;
    margin-bottom: 39px;

  }
  .technological-box1-t1{
    position: relative;
  }
  .technological-box1 .technological-box1-t1 .img1{
    width: 463px;
    height: 511px;
  }
  .technological-box1 .technological-box1-t1 span{
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
  }
  .technological-box1 .technological-box1-t1 .img2{
    position: absolute;
    top: 70px;
    left: 680px;
    height: 40px;
  }
  .technological-box1 .technological-box1-t1 .img3{
    position: absolute;
    top: 127px;
    left: 323px;
    height: 40px;
  }
  .technological-box1 .t1{
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .technological-box1 .t2{
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    line-height: 2;
    margin-bottom: 50px;
  }

  .technological-box2{
    width: 100%;
    height: 647px;
    background-image: url("../../assets/imgs/technological/5.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding-top: 56px;
  }

  .technological-box3{
    width: 100%;
  }
  .technological-box3 img{
    width: 100%;
  }
  .technological-box2 .box2-t1{
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
  }
  .technological-box2 .box2-li{
    width: 287px;
    height: 412px;
    border: 1px solid #FFFFFF;
    position: relative;
    opacity: 1;
    border-radius: 8px;
    overflow: hidden;
  }
  .technological-box2 .box2-ul{
    margin-top: 65px;
  }
  .technological-box2 .box2-lis{
    filter: blur(15px);
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(25,32,59,0.3900);
    z-index:0 ;
    top: 0;
    left: 0;
  }
  .technological-box2 .box2-li-header{
    background: #19203B;
    width: 100%;
    height: 81px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    padding: 0 24px;
    box-sizing: border-box;
    color: #FFFFFF;
    position: relative;
    z-index: 1;
  }
  .technological-box2 .box2-li-header .line{
    height: 26px;
    width: 1px;
    background-color: #FFFFFF;
    margin: 0 16px 0 16px;
  }
  .technological-box2 ul{
    margin: 41px 0 0;
    padding: 0;
  }
  .technological-box2 li{
    list-style: none;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    padding: 0 15px 0 15px;
    margin-bottom: 32px;
    position: relative;
    z-index: 1;
    margin-left: 35px;
  }
  .technological-box2 li:after{
    content: " ";
    position: absolute;
    width: 10px;
    height: 10px;
    background: rgba(0,113,239,1);
    top: 8px;
    opacity: 1;
    left: -10px;
    border-radius: 5px;

  }
  .technological-box7{

  }
  .technological-box7 .box7-title{
    font-size: 40px;
    font-family: Microsoft YaHei;
    text-align: center;
    font-weight: bold;
    margin-top: 40px;
    color: #19203B;
  }

  .technological-box7 .box7-ul{
    display: grid;
    margin-top: 40px;
    grid-template-columns: repeat(2,590px);
    grid-gap: 18px;
    grid-template-rows: repeat(3,240px);
  }
  .technological-box7 .box7-ul .box7-li{
    width: 592px;
    border-radius: 8px;
    background-color: #F1F3F9;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 240px;
    padding: 80px 40px;
    box-sizing: border-box;
  }
  .technological-box7 .box7-ul .box7-li img{
    position: absolute;
    top: 0;
    width: 170px;
    left: 0;
  }
  .technological-box7 .box7-ul .box7-li .text1{
    position: absolute;
    top: 0;
    left: 0;
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    width: 150px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .technological-box7 .box7-ul .box7-li:hover{
    background: linear-gradient(135deg, rgba(52, 228, 170, 0.32) 0%, rgba(44, 104, 255, 0.32) 100%);
  }

  .technological-box7 .box7-ul .box7-li .box7-li-text{
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #0071EF;
  }
  .technological-box7 .box7-ul .box7-li .box7-li-text2{
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 23px;
    margin-right: 20px;
    display: -webkit-inline-box;
  }

  .technological-box4{
    padding-top: 64px;
  }
  .technological-box4 .box4-title{
    font-size: 28px;
    font-family: Microsoft YaHei;
    text-align: center;
    font-weight: bold;
    color: #19203B;
  }
  .technological-box4 .box4-ul{
    margin-top: 40px;
  }
  .technological-box4 .box4-ul .box4-li{
    width: 590px;
    height: 200px;
    border-radius: 8px;
    background-color: #F1F3F9;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .technological-box4 .box4-ul{
    display: grid;
    grid-template-columns: repeat(2,590px);
    grid-gap: 18px;
    grid-template-rows: repeat(3,200px);
  }

  .technological-box4 .box4-ul .box4-li:hover{
    background: linear-gradient(135deg, rgba(52, 228, 170, 0.32) 0%, rgba(44, 104, 255, 0.32) 100%);
  }
  .technological-box4 .box4-ul .box4-li .box4-li-header{
    width: 590px;
    height: 56px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    padding-left: 40px;
    box-sizing: border-box;
    font-weight: 400;
    color: #FFFFFF;
    background-color: #308BF1;
    align-items: center;
  }
  .technological-box4 .box4-ul .box4-li .box4-li-content{
    width: 100%;
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    box-sizing: border-box;
    padding:20px 40px;
    text-overflow: ellipsis;
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    align-items: center;
    justify-content: flex-start;
  }
  .technological-box5{
    margin-top: 64px;
  }

  .technological-box5 .box5-title2{
    background: #FFFFFF;
    height: 114px;
    font-size: 18px;
    padding-left: 17px;
    line-height: 114px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #19203B;
  }
  .technological-box5 .box5-title{
    font-size: 28px;
    font-family: Microsoft YaHei;
    text-align: center;
    font-weight: bold;
    color: #19203B;
  }

</style>



// WEBPACK FOOTER //
// src/view/technological/index.vue